import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_shop_footer",
  tabindex: "-1",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "d-flex flex-stack" }
const _hoisted_8 = { class: "me-5 account-status-msg-area" }
const _hoisted_9 = { class: "fs-5 fw-bold" }
const _hoisted_10 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_11 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_12 = { class: "modal-footer flex-center" }
const _hoisted_13 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_14 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "editShopFooterForm",
          model: _ctx.editShopFooterData
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t("message.EDIT")) + " " + _toDisplayString(_ctx.$t("message.SHOP_FOOTER")), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Select, {
                name: "categories",
                target: "categories",
                categories: _ctx.editShopFooterData.categories,
                "onUpdate:categories": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editShopFooterData.categories = $event)),
                selectData: _ctx.categoriesList,
                filterable: true,
                multiple: true,
                clearable: true,
                required: true,
                requiredMsg: `${_ctx.$t('message.CATEGORIES')} ${_ctx.$t('message.IS_REQUIRED')}`,
                placeholder: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.CATEGORIES')}`,
                value: _ctx.editShopFooterData.categories,
                multipleLimit: 4
              }, null, 8, ["categories", "selectData", "requiredMsg", "placeholder", "value"]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("message.SHOP_FOOTER")), 1),
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("message.FOOTER_CATEGORIES_ACTIVATE_AND_DEACTIVATE")), 1)
                ]),
                _createVNode("span", _hoisted_11, [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.editShopFooterData.status,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editShopFooterData.status = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("button", _hoisted_13, _toDisplayString(_ctx.$t("message.CANCEL")), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitShopFooterForm()))
              }, [
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("message.SUBMIT")), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}